import { render, staticRenderFns } from "./InfiniteTable.vue?vue&type=template&id=57550cc5&"
import script from "./InfiniteTable.vue?vue&type=script&lang=js&"
export * from "./InfiniteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports